const gridLogin = {
 text1: 'Hello ',
 text2: ', the following login will be entered into your account:'
};

export default gridLogin;
